import { initApp } from './app';

document.addEventListener('DOMContentLoaded', () => {
  initApp();
});
